var cookieList = function(cookieName) {
    var cookie = jQuery.cookie(cookieName);
    var items = cookie ? cookie.split(/;/) : new Array();

    return {
        "add": function(val) {
            items.push(val.toString());
            jQuery.cookie(cookieName, items.join(';'), { expires: 7, path: '/' });
        },
        "remove": function (val) { 
            jQuery.each(list.items(), function( index, value ) {
                if ( value ) {
                    var obj = JSON.parse(value);
                    if (obj.id == val.toString()) {
                        items.splice(index, 1); 
                        jQuery.cookie(cookieName, items.join(';'), { expires: 7, path: '/' });
                    }
                }
            });
            // var indx = items.indexOf(val.toString());
            // if(indx!=-1) items.splice(indx, 1); 
            //jQuery.cookie(cookieName, items.join(';'), { expires: 7, path: '/' });
        },
        "clear": function() {
            items = null;
            jQuery.cookie(cookieName, items, { expires: 0, path: '/' });
        },
        "items": function() {
            return items;
        }
    }
}

var list = new cookieList("MyChoices");

//console.log(list.items());

jQuery(document).on('click','.single-formations .btn-add',function(){
    Fancybox.close();

    var obj = {};
    obj['id'] = jQuery(this).data('id');
    if ( jQuery(this).data('date') ) {
        obj['date'] = jQuery(this).data('date');
    } else {
        obj['date'] = 0;
    }

    if ( jQuery(this).data('participants') ) {
        obj['participants'] = jQuery(this).data('participants');
    } else {
        obj['participants'] = 0;
    }

    if ( jQuery(this).data('formule') ) {
        obj['formule'] = jQuery(this).data('formule');
    } else {
        obj['formule'] = 0;
    }
    
    list.add(JSON.stringify(obj)); 

    // jQuery(".single-formations .btn-add, .btn-add-inter").hide();
    // jQuery(".single-formations .btn-remove").show();
    jQuery(".single-formations .btn-add[data-id='" + obj['id'] + "'], .single-formations .btn-add-inter[data-inter='" + obj['id'] + "']").hide();
    jQuery(".single-formations .btn-remove[data-id='" + obj['id'] + "']").show();

    if ( jQuery('.liste-choix').length ) {
        jQuery('.liste-choix').empty();
        jQuery.post(
            ajaxurl, {
                'action': 'mychoices',
                'type': 'POST',
                'data': list.items(),
            },
            function(response) {
                jQuery('.liste-choix').append(response);

                if ( list.items().length != 0 ) {
                    jQuery('.formations-choisies').show();
                    jQuery('.formations-choisies-vide').hide();

                    // if (!jQuery('.button-choices').hasClass('open')) {
                    //     jQuery('.button-choices').trigger('click');
                    // }

                    jQuery('#cart .cart-overlay').addClass('open');
                    jQuery('#cart .checkpoint').addClass('open');
                    jQuery('.cart-validate').removeClass('disabled');
                } else {
                    jQuery('.formations-choisies').hide();
                    jQuery('.formations-choisies-vide').show();
                    jQuery('.cart-validate').addClass('disabled');
                }

                jQuery('.counter').text(list.items().length);
            }
        );
    }
});

jQuery(document).on('click','.single-formations .btn-remove',function(){
    var obj = {};
    obj['id'] = jQuery(this).data('id');

    list.remove(obj['id']); 

    // jQuery(".single-formations .btn-remove").hide();
    // jQuery(".single-formations .btn-add, .btn-add-inter").show();
    jQuery(".single-formations .btn-remove[data-id='" + obj['id'] + "']").hide();
    jQuery(".single-formations .btn-add[data-id='" + obj['id'] + "'], .single-formations .btn-add-inter[data-inter='" + obj['id'] + "']").show();
    

    if ( jQuery('.liste-choix').length ) {
        jQuery('.liste-choix').empty();
        jQuery.post(
            ajaxurl, {
                'action': 'mychoices',
                'type': 'POST',
                'data': list.items(),
            },
            function(response) {
                jQuery('.liste-choix').append(response);

                if ( list.items().length != 0 ) {
                    jQuery('.formations-choisies').show();
                    jQuery('.formations-choisies-vide').hide();
                    jQuery('.cart-validate').removeClass('disabled');
                } else {
                    jQuery('.formations-choisies').hide();
                    jQuery('.formations-choisies-vide').show();
                    jQuery('.cart-validate').addClass('disabled');
                }

                jQuery('.counter').text(list.items().length);
            }
        );
    }
});

jQuery(".single-formations .btn-remove").hide();
jQuery('.counter').text(list.items().length);

if ( list.items().length != 0 ) {
    jQuery.each(list.items(), function( index, value ) {
        //alert( index + ": " + value );
        var obj = JSON.parse(value);
        jQuery(".single-formations .btn-add[data-id='" + obj.id + "'], .single-formations .btn-add-inter[data-inter='" + obj.id + "']").hide();
        jQuery(".single-formations .btn-remove[data-id='" + obj.id + "']").show();
    });

    if ( jQuery('.liste-choix').length ) {
        jQuery.post(
            ajaxurl, {
                'action': 'mychoices',
                'type': 'POST',
                'data': list.items(),
            },
            function(response) {
                jQuery('.liste-choix').append(response);
            }
        );
    }

    if ( jQuery('.liste-choix-form').length ) {
        jQuery.post(
            ajaxurl, {
                'action': 'mychoicesform',
                'type': 'POST',
                'data': list.items(),
            },
            function(response) {
                jQuery('.liste-choix-form').append(response);
            }
        );
    }

    jQuery('.formations-choisies').show();
    jQuery('.formations-choisies-vide').hide();
    jQuery('.cart-validate').removeClass('disabled');
} else {
    jQuery('.formations-choisies').hide();
    jQuery('.formations-choisies-vide').show();
    jQuery('.cart-validate').addClass('disabled');
}
//list.clear();
jQuery(document).on('click', '.page-template-page-choix .btn-remove, #cart .btn-remove', function(e) {
    var formation_id = jQuery(this).data('id');
    list.remove(formation_id); 
    jQuery(this).parent().remove();
    jQuery(".single-formations .btn-add[data-id='" + formation_id + "'], .single-formations .btn-add-inter[data-inter='" + formation_id + "']").show();
    jQuery(".single-formations .btn-remove[data-id='" + formation_id + "']").hide();

    if ( list.items().length != 0 ) {
        jQuery('.formations-choisies').show();
        jQuery('.formations-choisies-vide').hide();
        jQuery('.cart-validate').removeClass('disabled');
    } else {
        jQuery('.formations-choisies').hide();
        jQuery('.formations-choisies-vide').show();
        jQuery('.cart-validate').addClass('disabled');
    }

    jQuery('.counter').text(list.items().length);
});

jQuery(document).on('click', '#cart .footer-continue, #cart .btn-close, #cart .cart-overlay.open', function(e) {
    jQuery('#cart .cart-overlay').removeClass('open');
    jQuery('#cart .checkpoint').removeClass('open');
});

jQuery(document).on('click', '.header-normal .button-choices, .header-fixed .button-choices', function(e) {
    jQuery('#cart .cart-overlay').addClass('open');
    jQuery('#cart .checkpoint').addClass('open');
});
